import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import BotonComponent from '../dashboard/components/BotonNuevo';
import { allReportesAction, setActivoReportesAction } from './ReportesAction';
import FormReportes from './components/FormReportes';
import { ModalComponent } from '../../widgets';
import CalendarioReportesComponent from './components/CalendarioReportes';

const ReportesView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const reportesStore = Redux.useSelector((state) => state.reportes);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoReportesAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoReportesAction(dispatch, null);
            await allReportesAction(dispatch, reportesStore.params);
          }}
          disabled={reportesStore.all.length === 0 || reportesStore.loadingAll}
          white
          refreshIcon
          text={reportesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      {/* <Grid item md={12}>
        <CalendarioReportesComponent setOpenModalForm={setOpenModalForm} />
      </Grid>
      <ModalComponent
        id="modalFormReportes"
        title={`${
          reportesStore.activo
            ? `Editar ${reportesStore.activo.nombre}`
            : 'Nuevo reporte'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormReportes
          activo={reportesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent> */}
    </Grid>
  );
};

export default ReportesView;
